module.exports = __webpack_public_path__ + "img/accept.d40436f6.png";